export function hideTextFields(textFields) {
  textFields.forEach((textField) => {
    textField.style.display = "none";
  });
}

export function showTextFields(textFields) {
  textFields.forEach((textField) => {
    textField.style.display = "block";
  });
}
